import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useApi, useFetch } from '@hooks';
import { useSaveServiceResponse } from '@store';
import { AccountCmdUrlInputDto, AccountCmdUrlOutputDto, AccountCmdUrlOutputDtoSingleOutputMessage } from '@types';

export const useFetchAccountCmdUrl = (): UseFetchHookOutput<AccountCmdUrlInputDto, AccountCmdUrlOutputDto> => {
	const { accountCmdUrl: fetchAccountCmdUrl } = useApi();
	const saveServiceResponse = useSaveServiceResponse();

	return useFetch<AccountCmdUrlInputDto, AccountCmdUrlOutputDto>({
		input: {
			fetchFn: fetchAccountCmdUrl,
			onSuccess: (res: AccountCmdUrlOutputDtoSingleOutputMessage) => {
				saveServiceResponse({ accountCmdUrl: res.data || {} });
			},
		},
		showGenericErrorModal: false,
		showGlobalLoader: false,
		requestName: 'account/cmdUrl',
	});
};
